var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLaptop = function SvgLaptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.592v-8.8c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218H6.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C3 6.112 3 6.672 3 7.792v8.8m1.667 4h14.666c.62 0 .93 0 1.185-.068a2 2 0 0 0 1.414-1.415c.068-.254.068-.564.068-1.184 0-.31 0-.465-.034-.592a1 1 0 0 0-.707-.707c-.127-.034-.282-.034-.592-.034H3.333c-.31 0-.465 0-.592.034a1 1 0 0 0-.707.707C2 17.46 2 17.615 2 17.925c0 .62 0 .93.068 1.184a2 2 0 0 0 1.414 1.415c.255.068.565.068 1.185.068Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgLaptop;